<template>
  <section class="collectList">
	<header-com isTransparent></header-com>
	<div class="titleWrap t_right bold f28"><i>想背的包</i> <span>{{pageConfig.total}}</span></div>
	<van-list v-model="isLoading"
			  :finished="isFinished"
			  v-if="list.length>0"
			  finished-text=" "
			  :offset="100"
			  :immediate-check="false"
			  @load="getList">
	  <ul class="list t_center">
		<li  v-for="(item,index) in list"
			 :key="index" @click="bagClick(item)">
		  <time  class="f28 bold l" v-html="getTime(item.createTime)"></time>
		  <div class="imgWrap ">
			<img :src="item.esProduct.baseProductPics[0]  | formatImgUrl(250,250,true)" align="middle">
		  </div>
		  <h3>{{item.esProduct.brandNameEn}}</h3>
		  <h3>{{item.esProduct.name+' '+item.esProduct.categoryName}}</h3>
		  <p class="f24">¥<span class="f48 bold">{{item.esProduct.price}}</span></p>
		</li>
	  </ul>
	</van-list>
	<no-data v-else type="no_collect"></no-data>
  </section>
</template>

<script>
  import packageApi from '@api/package'
  import publicObj from '@utils/public'
  import { mapActions } from 'vuex'
  export default {
    name: "index",
    data() {
      return {
        isLoading: false,
        isFinished: false,
        list: [],
        pageConfig: {
          pageNum:1,
          pageSize:10,
          total:0
        },
        // isShowNoData:false
	  }
    },
    watch: {},
    computed: {},
    created() {
      this.getList()
    },
    mounted() {
    },
    methods: {
      ...mapActions({
        addViewHistory:'user/addViewHistory'
			}),
			
			bagClick(item){
				let proDetail=item.esProduct
				//诸葛：我的背包-想背的包
          zhuge.track('我的背包-想背的包', {
            "商品名称":proDetail.brandNameEn+' '+proDetail.name+' '+proDetail.categoryName,
            "品牌":proDetail.brandNameEn,
            "价格":proDetail.price,
            "商品等级":proDetail.attributes[0].value
          });
				this.addViewHistory(item.esProduct.id)
			},

      // 获取收藏列表
      getList() {
        packageApi.getCollectsList({
          ...this.pageConfig,
        }).then(res => {
          let list = [...this.list];
          this.isLoading = false;
          this.list = list.concat(res.result);
          this.pageConfig.total = res.total;
          if(this.list.length >= this.pageConfig.total){
            this.isFinished = true;
          }else {
            this.pageConfig.pageNum++;
          }
          // res.total === 0? this.isShowNoData = true: this.isShowNoData = false
        }).catch(res => {
          // this.isLoading = false;
          console.log(res)
        })
      },
      // 获取时间
      getTime(createTime){
        return publicObj.formatTime(createTime)
      }
	}

  }
</script>
<style lang="scss">
  .collectList{
	.list time i{
	  vertical-align: top;
	  &:first-child{
		font-size:80px;
		line-height: 92px;
	  }
	  &:last-child{
		line-height: 68px;
	  }
	}
  }
</style>
<style lang="scss" scoped>
.collectList{
  /*color: transparent;*/
  .titleWrap{
	height: 170px;
	padding: 44px 36px 0;
	line-height: 40px;
	i,span{
	  vertical-align: middle;
	}
	span{
	  font-size: 50px;
	  margin-left: 30px;
	}
  }
  .list{
	padding: 0 60px;
	li{
	  width:630px;
	  height:688px;
	  margin-bottom: 32px;
	  box-shadow:$base-shadow;
	  border-radius:60px;
	  padding: 40px 66px ;
	  box-sizing: border-box;
	  .imgWrap{
		padding: 106px 0 34px;
		img{
		  width: 270px;
		  height: 270px;
		}
	  }
	  h3{
		font-size: 26px;
		margin-bottom: 6px;
	  }
	  p{
		padding-top: 30px;
	  }
	}
  }
}
</style>
